// src/hooks/useCheckoutForm.ts

import { useState } from "react";
import { validatePhone, containsInvalidChar } from "@/utils/validation";

export const useCheckoutForm = () => {
  // Дані платника
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [address, setAddress] = useState("");
  const [comment, setComment] = useState("");

  // Дані отримувача
  const [receiverFirstName, setReceiverFirstName] = useState("");
  const [receiverLastName, setReceiverLastName] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");
  const [receiverEmail, setReceiverEmail] = useState("");
  const [receiverCountry, setReceiverCountry] = useState("");
  const [receiverCity, setReceiverCity] = useState("");
  const [receiverPostal, setReceiverPostal] = useState("");
  const [receiverAddress, setReceiverAddress] = useState("");

  // Прапорець різних адрес
  const [useDifferentAddress, setUseDifferentAddress] = useState(false);

  // Помилки
  const [errors, setErrors] = useState<{
    country?: string;
    phone?: string;
    receiverPhone?: string;
    address?: string;
  }>({});

  // Обробка зміни телефону платника
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPhone(value);

    if (containsInvalidChar(value)) {
      setErrors((prev) => ({
        ...prev,
        phone: "Bitte nur Ziffern und + eingeben",
      }));
    } else {
      setErrors((prev) => {
        const { phone, ...rest } = prev;
        return rest;
      });
    }
  };

  // Обробка зміни телефону отримувача
  const handleReceiverPhoneChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    setReceiverPhone(value);

    if (containsInvalidChar(value)) {
      setErrors((prev) => ({
        ...prev,
        receiverPhone: "Bitte nur Ziffern eingeben",
      }));
    } else {
      setErrors((prev) => {
        const { receiverPhone, ...rest } = prev;
        return rest;
      });
    }
  };

  // Перевірка при втраті фокусу
  const handleBlurPhone = () => {
    if (phone.trim() && !validatePhone(phone)) {
      setErrors((prev) => ({
        ...prev,
        phone: "Ungültige Telefonnummer",
      }));
    }
    if (receiverPhone.trim() && !validatePhone(receiverPhone)) {
      setErrors((prev) => ({
        ...prev,
        receiverPhone: "Ungültige Telefonnummer des Empfängers",
      }));
    }
  };

  // Валідація форми
  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!country) newErrors.country = "Bitte Land auswählen.";
    if (!validatePhone(phone)) newErrors.phone = "Ungültige Telefonnummer.";
    if (!address) newErrors.address = "Adresse ist erforderlich.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Очищення форми
  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setPhone("");
    setEmail("");
    setComment("");
    setCountry("");
    setCity("");
    setPostal("");
    setAddress("");
    setReceiverFirstName("");
    setReceiverLastName("");
    setReceiverPhone("");
    setReceiverEmail("");
    setReceiverAddress("");
    setReceiverCity("");
    setReceiverPostal("");
    setReceiverCountry("");
    setUseDifferentAddress(false);
    setErrors({});
  };

  // Отримання всіх даних форми
  const getFormData = () => ({
    firstName,
    lastName,
    phone,
    email,
    country,
    city,
    postal,
    address,
    comment,
    useDifferentAddress,
    receiverFirstName,
    receiverLastName,
    receiverPhone,
    receiverEmail,
    receiverCountry,
    receiverCity,
    receiverPostal,
    receiverAddress,
  });

  return {
    // Стани
    firstName,
    lastName,
    phone,
    email,
    country,
    city,
    postal,
    address,
    comment,
    receiverFirstName,
    receiverLastName,
    receiverPhone,
    receiverEmail,
    receiverCountry,
    receiverCity,
    receiverPostal,
    receiverAddress,
    useDifferentAddress,
    errors,

    // Сеттери
    setFirstName,
    setLastName,
    setPhone,
    setEmail,
    setCountry,
    setCity,
    setPostal,
    setAddress,
    setComment,
    setReceiverFirstName,
    setReceiverLastName,
    setReceiverPhone,
    setReceiverEmail,
    setReceiverCountry,
    setReceiverCity,
    setReceiverPostal,
    setReceiverAddress,
    setUseDifferentAddress,

    // Обробники
    handlePhoneChange,
    handleReceiverPhoneChange,
    handleBlurPhone,

    // Методи
    validateForm,
    resetForm,
    getFormData,
  };
};
